/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data) {
  const [category, setCategory] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setCategory(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>عنوان</th>
            <th>مربوط به</th>
            <th>ترتیب</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {category ? category.map(item => (
              <tr key={item._id}>
                <td>{item.title}</td>
                <td>{item.shop[0].name + '(' + item.shop[0].description + ')'}</td>
                <td>{item.level}</td>
                <td>
                  <button onClick={() => navigate(`/categories/edit/${item._id}`)}>ویرایش</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
